import { SEO } from "../components/SEO";
import { ReviewsSection } from "../components/ReviewsSection";
import { SectionHeading } from "../components/Reveal";
import { CTABand } from "../components/CTABand";

export default function ReviewsPage() {
  return (
    <>
      <SEO
        title="Customer Reviews | My Mobile Mechanic — Mobile Brake Replacement"
        description="Read real customer reviews of My Mobile Mechanic's mobile brake replacement across Middlesex County, MA and Southern NH. Warranty-backed work, upfront pricing."
        path="/reviews"
      />
      <section className="border-b border-edge">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24">
          <SectionHeading
            eyebrow="Customer Reviews"
            title="What Your Neighbors Say"
            sub="Every review below is from a real mobile brake job in our service area. See even more on our Google Business Profile."
          />
        </div>
      </section>
      <ReviewsSection showHeading={false} />
      <CTABand title="Ready to Be the Next Five-Star Review?" />
    </>
  );
}
